import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';

const awardsData = [
    {
        id: 1,
        rank: "No. 1",
        description: "on the Great Place To Work® Fortune World's Best Workplaces™, our 4th consecutive year on the list.",
    },
    {
        id: 2,
        rank: "No. 1",
        description: "on the Great Place To Work® Fortune World's Best Workplaces™, our 4th consecutive year on the list.",
    },
    {
        id: 3,
        rank: "No. 10",
        description: "on the Great Place To Work® Fortune World's Best Workplaces™, our 4th consecutive year on the list.",
    },
    {
        id: 4,
        rank: "No. 5",
        description: "on the Great Place To Work® Fortune World's Best Workplaces™, our 4th consecutive year on the list.",
    }
];

const TrustedLeaderSection = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [loaded, setLoaded] = useState(false);

    const [sliderRef, instanceRef] = useKeenSlider(
        {
            initial: 0,
            loop: true,
            slideChanged(slider) {
                setCurrentSlide(slider.track.details.rel);
            },
            created() {
                setLoaded(true);
            },
            breakpoints: {
                "(min-width: 640px)": {
                    slides: { perView: 2.2, spacing: 20 },
                },
                "(min-width: 1024px)": {
                    slides: { perView: 3, spacing: 24 },
                },
            },
            slides: { perView: 1.1, spacing: 16 },
        },
        [
            (slider) => {
                let timeout;
                let mouseOver = false;
                function clearNextTimeout() {
                    clearTimeout(timeout);
                }
                function nextTimeout() {
                    clearTimeout(timeout);
                    if (mouseOver) return;
                    timeout = setTimeout(() => {
                        slider.next();
                    }, 3000);
                }
                slider.on("created", () => {
                    slider.container.addEventListener("mouseover", () => {
                        mouseOver = true;
                        clearNextTimeout();
                    });
                    slider.container.addEventListener("mouseout", () => {
                        mouseOver = false;
                        nextTimeout();
                    });
                    nextTimeout();
                });
                slider.on("dragStarted", clearNextTimeout);
                slider.on("animationEnded", nextTimeout);
                slider.on("updated", nextTimeout);
            },
        ]
    );

    return (
        <section className="w-full py-[40px] md:py-[100px] bg-white font-graphik overflow-hidden">
            <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">
                <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-[32px] md:mb-[60px] gap-[16px] md:gap-[60px]">
                    <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        variants={{
                            lg: { initial: { opacity: 0, x: -30, y: 0 }, whileInView: { opacity: 1, x: 0, y: 0 } }
                        }}
                        className="w-full lg:w-[45%]"
                    >
                        <h2 className="text-[20px] md:text-[30px] font-[600] font-sora text-[#01386A] tracking-tight leading-tight">
                            A trusted industry leader
                        </h2>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.8, ease: "easeOut", delay: 0.1 }}
                        variants={{
                            lg: { initial: { opacity: 0, x: 30, y: 0 }, whileInView: { opacity: 1, x: 0, y: 0 } }
                        }}
                        className="w-full lg:w-[55%] max-w-[500px]"
                    >
                        <p className="text-[#6C7689] text-[14px] lg:text-[16px] font-graphik font-[500] leading-[1.6]">
                            We are the reinvention partner of choice for our clients, and our strategy is to be the most client-focused, AI-enabled, great place to work for Reinventors.
                        </p>
                    </motion.div>
                </div>

                <div className="relative">
                    <div ref={sliderRef} className="keen-slider !overflow-visible lg:!overflow-hidden">
                        {awardsData.map((award, idx) => (
                            <div className="keen-slider__slide h-full" key={award.id}>
                                <motion.div
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, amount: 0.1 }}
                                    transition={{ duration: 0.6, delay: idx * 0.1, ease: "easeOut" }}
                                    className="group h-full flex flex-col justify-center min-h-[220px] sm:min-h-[260px] md:min-h-[280px] p-[24px] sm:p-[30px] md:p-[40px] bg-white border border-[#E4E8F5] md:hover:bg-[#01386A] md:hover:border-[#01386A] transition-colors duration-300 rounded-sm"
                                >
                                    <h3 className="font-sora text-[16px] md:text-[20px] font-[600] mb-[12px] md:mb-[30px] text-[#01386A] md:group-hover:text-white transition-colors duration-300">
                                        {award.rank}
                                    </h3>
                                    <p className="text-[14px] lg:text-[16px] font-[500] font-graphik leading-[1.6] text-[#49577A] md:group-hover:text-white transition-colors duration-300">
                                        {award.description}
                                    </p>
                                </motion.div>
                            </div>
                        ))}
                    </div>

                    {loaded && instanceRef.current && (
                        <div className="flex items-center gap-[16px] mt-[24px] md:mt-[40px]">
                            <button
                                onClick={(e) => e.stopPropagation() || instanceRef.current?.prev()}
                                className="w-[40px] h-[40px] flex items-center justify-center rounded-full border border-[#ED6800] text-[#ED6800] hover:bg-[#ED6800] hover:text-white transition-colors"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M19 12H5M12 19l-7-7 7-7" />
                                </svg>
                            </button>
                            <button
                                onClick={(e) => e.stopPropagation() || instanceRef.current?.next()}
                                className="w-[40px] h-[40px] flex items-center justify-center rounded-full border border-[#ED6800] text-[#ED6800] hover:bg-[#ED6800] hover:text-white transition-colors"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M5 12h14M12 5l7 7-7 7" />
                                </svg>
                            </button>
                        </div>
                    )}
                </div>

            </div>
        </section>
    );
};

export default TrustedLeaderSection;